module.exports = "/_next/static/images/BuildDeeper-a401dfe07bdb5fd0a61a99fcbc180bb6.webp";